module.exports = __webpack_public_path__ + "static/media/om_eyebrowshape_softangled_vector.c4e15308.svg";